<template>
    <div class="l content_right flex_container p10">
        <div class="left-section">
            <div class="title cl">
                <span class="l">资源组</span>
                <el-button class="r" type="primary" @click="addResourceGroup">新增</el-button>
            </div>
            <ul>
                <li v-for="item in groupList" class="cl">
                    <span class="l name" :class="{active: item.resourcegroupid === curGroup.resourcegroupid}" @click="switchGroup(item)">{{item.resourcegroupname}}</span>
                    <span class="r edit" title="编辑" @click="editGroup(item)"></span>
                    <span class="r delete" title="删除" @click="deleteGroup(item.resourcegroupid)"></span>
                </li>
            </ul>
        </div>
        <div class="right-section">
            <div class="title cl">
                <label class="l">资源类型:</label>
                <span class="l type-item" :class="{active:resourceType == '0'}" @click="switchResourceType(0)">服务资源</span>
                <span class="l type-item" :class="{active:resourceType == '1'}" @click="switchResourceType(1)">客户端使用资源</span>
                <span class="l type-item" :class="{active:resourceType == '2'}" @click="switchResourceType(2)">服务端使用资源</span>
                <span class="l type-item" :class="{active:resourceType == '3'}" @click="switchResourceType('3')">不限</span>
                <el-button class="r" type="primary" @click="addResource">新增</el-button>
            </div>
            <div class="table_container">
                <el-table :data="resourceList" :height="tableHeight">
                    <el-table-column label="资源名称">
                        <template scope="scope">
                            <a @click="editResource(scope.row)">{{scope.row.resourcename}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="resourcetype" label="类型"></el-table-column>
                    <el-table-column prop="resourcekey" label="资源KEY"></el-table-column>
                    <el-table-column label="操作">
                        <template scope="scope">
                            <a @click="deleteResource(scope.row.resourceid)">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :title="diaTitle.resourceGroup" v-model="dia.resourceGroup">
            <resource-group v-if="dia.resourceGroup" @cancel="cancelResourceGroup" @refresh="refreshResourceGroup" :config="configGroup"></resource-group>
        </el-dialog>
        <el-dialog :title="diaTitle.resource" v-model="dia.resource">
            <resource v-if="dia.resource" @cancel="cancelResource" @refresh="refreshResource" :config="configResource"></resource>
        </el-dialog>
    </div>
</template>
<script>
    import {errorMessage} from '../../util'
    import {API_ROOT} from '../../config/index'
    import resourceGroup from './groupEdit'
    import resource from './resourceEdit'
    export default {
        data: function(){
            return {
                groupList: [],
                resourceList: [],
                curGroup: {
                    resourcegroupid: '',
                    resourcegroupkey: '',
                    resourcegroupname: ''
                },
                configGroup: {},
                configResource: {},
                dia: {
                    resourceGroup: false,
                    resource: false
                },
                diaTitle: {
                    resourceGroup: '编辑资源组',
                    resource: '编辑资源'
                },
                resourceType: '3',
                tableHeight: ''
            }
        },
        components: {
            resourceGroup,
            resource
        },
        created: function(){
            this.loadGroupListData(data => {
                this.updateCurGroup(data[0])
                this.loadResourceListData(data[0].resourcegroupid)
            })
        },
        mounted: function(){
            let contentRight = document.getElementsByClassName('content_right')
            this.tableHeight =  contentRight[0].clientHeight  - 89
        },
        methods: {
            addResourceGroup(){
                this.configGroup = {}
                this.diaTitle.resourceGroup = '新增资源组' 
                this.dia.resourceGroup = true
            },
            editGroup(item){
                this.configGroup = item
                this.diaTitle.resourceGroup = '编辑资源组'
                this.dia.resourceGroup = true
            },
            deleteGroup(code){
                this.$confirm('确定删除？', '提示').then(() => {
                    this.$http.post(`/resourceconfig/resourcegroup/delete`,{
                        resourcegroupid: code
                    }).then(function(res){
                        this.$message('删除成功！')
                        this.loadGroupListData(data => {
                            if(code === this.curGroup.resourcegroupid){
                                this.updateCurGroup(this.data[0])
                                this.loadResourceListData(data[0].resourcegroupid)
                            }
                        })
                        this.refreshResourceGroup()
                    }).catch(error => {
                        errorMessage(error, this)
                    })
                }).catch(() => {})
            },
            switchGroup(item){
                this.updateCurGroup(item)
                this.loadResourceListData(item.resourcegroupid)
            },
            // 更新当前资源组信息
            updateCurGroup(data){
                for(let i in this.curGroup) {
                    this.curGroup[i] = data[i] ? data[i] : ''
                }
            },
            cancelResourceGroup(){
                this.dia.resourceGroup = false
            },
            refreshResourceGroup(){
                this.loadGroupListData()
                this.loadResourceListData(this.curGroup.resourcegroupid)
            },
            switchResourceType(type){
                this.resourceType = type
                this.loadResourceListData(this.curGroup.resourcegroupid)
            },
            addResource(){
                this.configResource = {resourcegroupid: this.curGroup.resourcegroupid}
                this.diaTitle.resource = '新增资源'
                this.dia.resource = true
            },
            editResource(row){
                this.configResource = row
                this.diaTitle.resource = '编辑资源'
                this.dia.resource = true
            },
            deleteResource(code){
                this.$confirm('确定删除？', '提示').then(() => {
                    this.$http.post(`/resourceconfig/resource/delete`,{
                        resourceid: code
                    }).then(function(res){
                        this.$message('删除成功！')
                        this.refreshResource()
                    }).catch(error => {
                        errorMessage(error, this)
                    })
                }).catch(() => {})
            },
            cancelResource(){
                this.dia.resource = false
            },
            refreshResource(){
                this.loadResourceListData(this.curGroup.resourcegroupid)
            },
            // 加载列表数据
            loadGroupListData(callback) {
                this.$http.post(`/resourceconfig/resourcegroup/list`,{}).then(function(res){
                    let respData = res.data.resp_data
                    this.groupList = respData
                    if (typeof callback === 'function') callback(respData)
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            loadResourceListData(code) {
                this.$http.post(`/resourceconfig/resource/list`,{
                    resourcegroupid: code,
                    resourcetype: this.resourceType === '3' ? '' : this.resourceType
                }).then(function(res){
                    this.resourceList = res.data.resp_data
                }).catch(error => {
                    errorMessage(error, this)
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?73dcafca